import React, { useState } from "react";
import styles from "./QuizInline.module.css";

export default function QuizInline({ questions }) {
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState(Array(questions.length).fill(null));
  const [selected, setSelected] = useState(null);
  const [done, setDone] = useState(false);
  const [correctCount, setCorrectCount] = useState(0);
  const [showSummary, setShowSummary] = useState(false);

  const q = questions[current];
  if (!q) return null;

  const selectOption = (index) => {
    if (done) return;
    setSelected(index);
  };

  const submitAnswer = () => {
    if (selected === null) return;

    const updated = [...answers];
    updated[current] = selected;
    setAnswers(updated);
    setDone(true);
  };

  const finishQuiz = () => {
    const updated = [...answers];

    if (updated[current] === null && selected !== null) {
      updated[current] = selected;
    }

    const count = updated.reduce(
      (acc, ans, i) => (ans === questions[i].correctIndex ? acc + 1 : acc),
      0
    );
    setAnswers(updated);
    setCorrectCount(count);
    setDone(true);
    setShowSummary(true);
  };

  const resetQuiz = () => {
    setAnswers(Array(questions.length).fill(null));
    setSelected(null);
    setCurrent(0);
    setDone(false);
    setCorrectCount(0);
    setShowSummary(false);
  };

  const goNext = () => {
    if (current < questions.length - 1) {
      setCurrent(current + 1);
      setSelected(answers[current + 1]);
      setDone(answers[current + 1] !== null);
    }
  };

  const goPrev = () => {
    if (current > 0) {
      setCurrent(current - 1);
      setSelected(answers[current - 1]);
      setDone(answers[current - 1] !== null);
    }
  };

  return (
    <div className={styles.container}>
      {!showSummary ? (
        <>
          <h4 className={styles.question}>
            Pregunta {current + 1} de {questions.length}
          </h4>
          <p className={styles.qText}>{q.text}</p>

          <ul className={styles.options}>
            {q.options.map((opt, i) => (
              <li key={i}>
                <button
                  className={`
                    ${styles.optionBtn}
                    ${selected === i ? styles.selected : ""}
                    ${done && i === q.correctIndex ? styles.correct : ""}
                    ${
                      done && selected === i && i !== q.correctIndex
                        ? styles.wrong
                        : ""
                    }
                  `}
                  onClick={() => selectOption(i)}
                  disabled={done}
                >
                  {opt}
                </button>
              </li>
            ))}
          </ul>

          <div className={styles.feedback}>
            {done && selected !== q.correctIndex && (
              <p className={styles.incorrectFeedback}>
                La respuesta correcta es:{" "}
                <strong>{q.options[q.correctIndex]}</strong>
              </p>
            )}
            {done && selected === q.correctIndex && (
              <p className={styles.correctFeedback}>¡Respuesta correcta! 🎉</p>
            )}
          </div>

          <div className={styles.actions}>
            {current > 0 && (
              <button className={styles.navBtn} onClick={goPrev}>
                Anterior
              </button>
            )}

            {!done && (
              <button
                className={styles.submitBtn}
                onClick={submitAnswer}
                disabled={selected === null}
              >
                Enviar
              </button>
            )}

            {done && current < questions.length - 1 && (
              <button className={styles.navBtn} onClick={goNext}>
                Siguiente
              </button>
            )}

            {done &&
              current === questions.length - 1 &&
              answers[current] !== null && (
                <button className={styles.finishBtn} onClick={finishQuiz}>
                  Finalizar
                </button>
              )}
          </div>
        </>
      ) : (
        <div className={styles.summary}>
          <h3>¡Has completado el cuestionario!</h3>
          <p>
            ✅ {correctCount} de {questions.length} respuestas correctas
          </p>
          {correctCount < questions.length ? (
            <p>🧠 Recomendamos repasar este tema para mejorar.</p>
          ) : (
            <p>🎉 ¡Excelente trabajo!</p>
          )}
          <button className={styles.resetBtn} onClick={resetQuiz}>
            Rehacer
          </button>
        </div>
      )}
    </div>
  );
}
